module.exports = __webpack_public_path__ + "static/media/ca-srb-bearing.e53526a9.jpg";